import { render, staticRenderFns } from "./index.vue?vue&type=template&id=463e7c16&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=463e7c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e7c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463e7c16')) {
      api.createRecord('463e7c16', component.options)
    } else {
      api.reload('463e7c16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=463e7c16&scoped=true&", function () {
      api.rerender('463e7c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/supplier-edit-dialog/index.vue"
export default component.exports